import { render, staticRenderFns } from "./CheckoutMessages.vue?vue&type=template&id=016bd0dd"
import script from "./CheckoutMessages.vue?vue&type=script&lang=js"
export * from "./CheckoutMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports